import { useCallback, useMemo, useState } from "react"
import { node } from "prop-types"
import AlertSnackbar from "@/components/AlertSnackBar"
import { SnackbarContext } from "@/hooks/useSnackbar"

function SnackbarProvider({ children }) {
  const [state, setState] = useState({
    open: false,
    message: "",
    severity: "info",
    autoHideDuration: undefined
  })

  // autoHideDuration is worth passing for the rare message that explains an
  // otherwise empty page: three seconds is not long enough to read one.
  const showSnackbar = useCallback(({ message, severity = "info", autoHideDuration }) => {
    setState({ open: true, message, severity, autoHideDuration })
  }, [])

  const closeSnackbar = useCallback(() => {
    setState((prev) => ({ ...prev, open: false }))
  }, [])

  const value = useMemo(() => ({ showSnackbar }), [showSnackbar])

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      <AlertSnackbar
        open={state.open}
        message={state.message}
        severity={state.severity}
        autoHideDuration={state.autoHideDuration}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      />
    </SnackbarContext.Provider>
  )
}

SnackbarProvider.propTypes = {
  children: node.isRequired
}

export default SnackbarProvider
